import React, { useState } from "react";
import { Chart } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Tooltip,
  Legend,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import Select from "~components/Form/components/Select";
import { CleanFiltersIcon } from "~misc/icons";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Tooltip,
  Legend,
  ChartDataLabels
);

const barColor = "#FF8A00";
const lineColor = "#034EA2";

const NegociacoesFuturas = ({
  data = [],
  productGroupOptions = [],
  statusOptions = [],
  hideFilters = false,
  onFilterChange,
}) => {
  const [productGroup, setProductGroup] = useState("");
  const [status, setStatus] = useState("");

  const handleProductGroup = (opt) => {
    setProductGroup(opt?.value ?? "");
    onFilterChange?.({ productGroup: opt?.value ?? "", status });
  };

  const handleStatus = (opt) => {
    setStatus(opt?.value ?? "");
    onFilterChange?.({ productGroup, status: opt?.value ?? "" });
  };

  const handleClear = () => {
    setProductGroup("");
    setStatus("");
    onFilterChange?.({ productGroup: "", status: "" });
  };

  const chartData = {
    labels: data.map((d) => d.label),
    datasets: [
      {
        type: "bar",
        label: "Volume de Obras",
        data: data.map((d) => d.volumeNegociado ?? 0),
        backgroundColor: barColor,
        borderRadius: 4,
        yAxisID: "y",
        datalabels: {
          anchor: "center",
          align: "center",
          color: "#fff",
          font: { size: 10, weight: "bold" },
          formatter: (v) => (v > 0 ? v.toLocaleString("pt-BR") : ""),
        },
      },
      {
        type: "line",
        label: "Qtd. de Obras",
        data: data.map((d) => d.qtdObras ?? 0),
        borderColor: lineColor,
        backgroundColor: lineColor,
        pointBackgroundColor: lineColor,
        pointBorderColor: lineColor,
        pointRadius: 14,
        pointHoverRadius: 16,
        tension: 0.3,
        yAxisID: "y2",
        datalabels: {
          anchor: "center",
          align: "center",
          color: "#fff",
          font: { size: 10, weight: "bold" },
          formatter: (v) => (v > 0 ? v : ""),
        },
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: { mode: "index", intersect: false },
    plugins: {
      legend: { display: false },
      tooltip: { enabled: true },
      datalabels: {},
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: { font: { size: 11 }, color: "#01054C" },
      },
      y: {
        position: "left",
        grid: { color: "#e5e7eb" },
        max: 30000,
        ticks: { font: { size: 10 }, color: "#01054C" },
        title: {
          display: true,
          text: "Volume Negociado",
          color: barColor,
          font: { size: 11, weight: "bold" },
        },
      },
      y2: {
        position: "right",
        grid: { display: false },
        min: -5,
        max: 36,
        ticks: {
          font: { size: 10 },
          color: "#01054C",
          stepSize: 5,
          callback: (v) => (v < 0 ? "" : v),
        },
        title: {
          display: true,
          text: "Quantidade de Obras",
          color: lineColor,
          font: { size: 11, weight: "bold" },
        },
      },
    },
    layout: { padding: { top: 10 } },
  };

  return (
    <div className="container mt-8">
      {!hideFilters && (
        <div className="flex flex-wrap items-end gap-4 mb-4">
          <div className="w-52">
            <Select
              options={productGroupOptions}
              label="Grupo de Produto:"
              name="productGroup"
              value={productGroupOptions.find((o) => o.value === productGroup) ?? null}
              onChange={handleProductGroup}
              placeholder="Selecione"
              spacingControl={true}
            />
          </div>

          <div className="w-52">
            <Select
              options={statusOptions}
              label="Status"
              name="status"
              value={statusOptions.find((o) => o.value === status) ?? null}
              onChange={handleStatus}
              placeholder="Selecione"
              spacingControl={true}
            />
          </div>

          <button
            type="button"
            onClick={handleClear}
            className="flex items-center gap-2 mb-4 text-sm font-semibold text-primaria ml-auto"
          >
            <span>Limpar Filtros</span>
            <CleanFiltersIcon />
          </button>
        </div>
      )}

      <div className="bg-white rounded-xl shadow px-6 pt-5 pb-4">
        <h3 className="text-center font-bold text-base mb-4">
          Negociações Futuras
        </h3>
        <div style={{ height: 280 }}>
          <Chart type="bar" data={chartData} options={chartOptions} />
        </div>
        <div className="flex items-center gap-6 mt-4 pl-[40px]">
          <div className="flex items-center gap-1.5">
            <span
              className="inline-block w-3 h-3 rounded-sm flex-shrink-0"
              style={{ backgroundColor: barColor }}
            />
            <span className="text-xs">Volume de Obras</span>
          </div>
          <div className="flex items-center gap-1.5">
            <span
              className="inline-block w-3 h-3 rounded-full flex-shrink-0"
              style={{ backgroundColor: lineColor }}
            />
            <span className="text-xs">Qtd. de Obras</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NegociacoesFuturas;
